<template>
  <div>
    <header class="Mybar"
            :class="{'bg_red': styleName === 'main','bg_use': styleName === 'main_b','bg_green': styleName === 'main_c'}">
      <div class="searchBox rel" v-on:click="toSearch">
        <span class="iconfont icon-sousuo iconSearch f12 color_999"></span>
        <input type="text" class="searchInput" placeholder="输入商品名称或粘贴淘宝标题"
               disabled="disabled"/>
      </div>
      <div class="mybarRight mt2" v-on:click='toCategory'>
        <span class="iconfont icon-icon1 color_fff f16"></span>&nbsp;
      </div>
    </header>
    <main class="MainCon" ref="mainCon" id="mainCon">
      <div v-if="bannerData.status">
        <div class="bannerBox">
          <div class="bannerImgBox">
            <div class="swiper-container bannerTabImg" id="swiperBanner">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in bannerData.list"
                     :key="index">
                  <a :href="item.url"><img :src="item.img_path"/></a>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="over">
            <div
                :class="{'bannerBgBox_damai': styleName === 'main','bannerBgBox': styleName === 'main_b','bannerBgBox_green': styleName === 'main_c'}"></div>
          </div>
        </div>
      </div>

      <div class="bg_white" v-else>
        <div class="pt10 pb10 ml7 mr7">
          <div class="loading-indexBanner"></div>
        </div>
      </div>

      <div class="indexMenuBox pt10">
        <ul class="indexMenuBoxList">
          <li v-on:click='toTopGoodsList("superrebate")'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon1.png"/></p>
            <p class="f8 lh18">超级返</p>
          </li>
          <li v-on:click='toTopGoodsList("supercoupon")'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon2.png"/></p>
            <p class="f8 lh18">超级券</p>
          </li>
          <li v-on:click='toJdGoodsMain()'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon3.png"/></p>
            <p class="f8 lh18">京东</p>
          </li>
          <li v-on:click='toPddGoodsMain()'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon4.png"/></p>
            <p class="f8 lh18">拼多多</p>
          </li>
          <li v-on:click='toTopGoodsList("nine")'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon5.png"/></p>
            <p class="f8 lh18">9.9包邮</p>
          </li>
          <li v-on:click='toTopRealList()'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon6.png"/></p>
            <p class="f8 lh18">实时榜单</p>
          </li>
          <li v-on:click='toTopBrandList()'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon7.png"/></p>
            <p class="f8 lh18">品牌清仓</p>
          </li>
          <li v-on:click='toTopFreeList()'>
            <p class="indexMenuBoxListImg"><img src="@/assets/images/nianhuo/navIcon8.png"/></p>
            <p class="f8 lh18">礼金专区</p>
          </li>
        </ul>
      </div>

      <div class="indexActivity_yellow mt10" v-show="advertAData.status">
        <div class="myimg" v-on:click="toUrl(advertAData.advert1.url)">
          <img :src="advertAData.advert1.img"/>
        </div>
        <div
            :class="{'indexActivityBox_red': styleName === 'main','indexActivityBox': styleName === 'main_b','indexActivityBox_green': styleName === 'main_c'}">
          <div class="indexActivityBoxMargin">
            <div class="flexBox flexBetween">
              <div class="flexBox-cell-48 myContentimg"
                   v-on:click="toUrl(advertAData.advert2.url)">
                <img :src="advertAData.advert2.img"/>
              </div>
              <div class="flexBox-cell-48 myContentimg"
                   v-on:click="toUrl(advertAData.advert3.url)">
                <img :src="advertAData.advert3.img"/>
              </div>
            </div>
            <div class="flexBox flexBetween mt7">
              <div class="flexBox-cell-48 myContentimg"
                   v-on:click="toUrl(advertAData.advert4.url)">
                <img :src="advertAData.advert4.img"/>
              </div>
              <div class="flexBox-cell-48 myContentimg"
                   v-on:click="toUrl(advertAData.advert5.url)">
                <img :src="advertAData.advert5.img"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg_white pt10 mt12 pb10">
        <div class="indexActivityBoxMargin">
          <div class="myimg" v-show="styleName === 'main'" v-on:click='toEnroll'><img
              src="@/assets/images/businessAd_red.png"/></div>
          <div class="myimg" v-show="styleName === 'main_b'" v-on:click='toEnroll'>
            <img
                src="@/assets/images/businessAd.png"/></div>
          <div class="myimg" v-show="styleName === 'main_c'" v-on:click='toEnroll'>
            <img
                src="@/assets/images/businessAd_green.png"/></div>
        </div>
      </div>

      <div class="bg_white myborderT">
        <div class="indexActivityBoxMargin pt5 pb5" v-if="headlineData.status">
          <div class="indexNewsBox rel">
            <div class="indexNewsImg" v-show="styleName === 'main'">
              <img src="@/assets/images/newsTitle_yellow.png"/>
            </div>
            <div class="indexNewsImg" v-show="styleName === 'main_b'">
              <img src="@/assets/images/newsTitle_red.png"/>
            </div>
            <div class="indexNewsImg" v-show="styleName === 'main_c'">
              <img src="@/assets/images/newsTitle_green.png"/>
            </div>
            <div class="indexNewsLine">|</div>
            <div class="swiper-container indexNewsBlock" id="headlines">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in headlineData.list"
                     :key="index" v-on:click="toArticleDetail(item.id)">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg_white pt5 pb5" v-else>
          <div class="indexActivityBoxMargin">
            <div class="loading-barblock"></div>
          </div>
        </div>
      </div>

      <div class="indexActivityBoxMargin" v-show="advertBData.status">
        <div class="flexBox mt12">
          <div class="flexBox-cell-50 myimg indexColumnBlockBR indexColumnBlockBB"
               v-on:click="toUrl(advertBData.advert1.url)">
            <img :src="advertBData.advert1.img"/>
          </div>
          <div class="flexBox-cell-50 myimg indexColumnBlockBB"
               v-on:click="toUrl(advertBData.advert2.url)">
            <img :src="advertBData.advert2.img"/>
          </div>
        </div>
        <div class="flexBox mt1">
          <div class="flexBox-cell-33 myimg indexColumnBlockBR"
               v-on:click="toUrl(advertBData.advert3.url)"
               style="z-index: 1;">
            <img :src="advertBData.advert3.img"/>
          </div>
          <div class="flexBox-cell-33 myimg indexColumnBlockBR"
               v-on:click="toUrl(advertBData.advert4.url)">
            <img :src="advertBData.advert4.img"/>
          </div>
          <div class="flexBox-cell-33 myimg" v-on:click="toUrl(advertBData.advert5.url)">
            <img :src="advertBData.advert5.img"/>
          </div>
        </div>
      </div>

      <div class="ml5 mr5">
        <div class="bg_white mt12" v-show="shopData.status">
          <div class="flexBox flexBetween bg_white lh30">
            <div class="ml7"><span
                class="titleIconBox_damai iconfont icon-shoucang"></span><span
                class="titleLineBlock_damai ml5">推荐店铺</span><em
                class="f8 color_999">&nbsp;&nbsp;·&nbsp;&nbsp;超级大牌 优质好店</em></div>
            <div class="mr7 color_999 f8" v-on:click='toShop'>更多&nbsp;<em
                class="iconfont icon-mjiantou-copy f8"></em></div>
          </div>
          <div class="flexBox" style="flex-wrap:wrap;">
            <div class="flexBox-cell-50 indexColumnBlockBT"
                 :class="{'indexColumnBlockBR': index%2 !== 1}"
                 v-for="(item,index) in shopData.list"
                 v-on:click="toShopDetail(item.id)" :key="index">
              <div class="ml7 mr7 pt10 pb5">
                <p class="tc" style="line-height: 60px;">
                  <img :src="item.shop_icon"
                       @load="autoResizeImage(0,60,$event)"/>
                </p>
                <p class="shopName">{{ item.shop_name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt12 pb10"
           :class="{'brandBoxBg':styleName === 'main','brandBoxBg_yellow':styleName === 'main_b','brandBoxBg_green':styleName === 'main_c'}"
           v-show="brandData.status">
        <div class="flexBox flexBetween lh30">
          <div class="ml7" v-show="styleName === 'main'"><img
              src="@/assets/images/brandTitleTxt.png" class="mt7"/></div>
          <div class="ml7" v-show="styleName === 'main_b' || styleName === 'main_c'">
            <img src="@/assets/images/brandTitleTxt_yellow.png" class="mt7"/></div>
          <div class="mr7 color_fff f8" v-on:click='toTopBrandList'>更多&nbsp;<em
              class="iconfont icon-mjiantou-copy f8"></em></div>
        </div>
        <div class="myimg ml5 mr5 mb5" v-on:click="toUrl(brandData.ad.url)">
          <img :src="brandData.ad.img"/>
        </div>
        <div class="ml5 mr5">
          <div class="flexBox myContentBox">
            <div class="flexBox-cell-33" v-for="(item,index) in brandData.list"
                 v-on:click="toTopGoodsDetail(item.num_iid)" :key="index">
              <div class="ml5 mr5">
                <ImageExt class="indexRecListImg mt5 tc" :src="item.pict_url"
                          mode="aspectFit"/>
                <p class="indexRecListTitle mt5">{{ item.title }}</p>
                <p class="f8 lh18"
                   :class="{'color_red': styleName === 'main','color_yellow': styleName === 'main_b','color_green': styleName === 'main_c'}">
                  ￥<em class="f12">{{ item.coupon_after_price }}</em></p>
                <p class="color_999 f8">月销&nbsp;{{ item.volume }}</p>
                <div class="flexBox mt7 mb10">
                  <div v-if="item.coupon_discount > 0">
                    <div class="paddingLR7"
                         :class="{'voucherBlock_damai': styleName === 'main','voucherBlock_damai_yellow':styleName === 'main_b','voucherBlock_damai_green':styleName === 'main_c'}">
                      {{ item.coupon_discount }}元券
                    </div>
                  </div>
                  <div v-else>
                    <div class="paddingLR7"
                         :class="{'voucherBlock_damai': styleName === 'main','voucherBlock_damai_yellow': styleName === 'main_b','voucherBlock_damai_green': styleName === 'main_c'}">
                      无券
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="myContentBox mt12" v-show="tljData.status">
        <div class="">
          <div class="flexBox flexBetween lh30">
            <div class="ml7"><span
                class="titleIconBox_damai iconfont icon-xiazai41 titleIconBg1_damai"></span><span
                class="titleLineBlock_damai ml5">礼金专区</span><em
                class="color_999 f8">&nbsp;&nbsp;·&nbsp;&nbsp;福利购 高佣又低价</em></div>
            <div class="mr7 color_999 f8" v-on:click='toTopFreeList'>更多&nbsp;<em
                class="iconfont icon-mjiantou-copy f8"></em></div>
          </div>

          <div class="myimg" v-on:click="toUrl(tljData.ad.url)"><img
              :src="tljData.ad.img"/></div>
          <div class="liGoodBox" v-for="(item, index) in tljData.list"
               v-on:click="toTopFreeList" :key="index">
            <div class="goodBoxImg"><img :src="item.pict_url"/></div>
            <div class="goodBoxBlock ml5">
              <div class="goodBoxTitle mt7">{{ item.title }}</div>
              <div class="flexBox mt7 mb5">
                <div v-if="item.coupon_discount > 0">
                  <div class="paddingLR7 voucherBlock_damai">
                    {{ item.coupon_discount }}元券
                  </div>
                </div>
                <div v-else>
                  <div class="paddingLR7 voucherBlock_damai">
                    无券
                  </div>
                </div>
                <div v-if="item.per_face > 0">
                  <div class="ml5 paddingLR7 voucherBlocks_damai">
                    {{ item.per_face }}元
                  </div>
                </div>
                <div v-else>
                  <div class="ml5 paddingLR7 voucherBlocks_damai">
                    无返利
                  </div>
                </div>
              </div>
              <div class="flexBox flexBetween mt5 mr5">
                <div class="f8 lh18">
                                    <span class="color_red">
                                        ￥<em class="f12">{{ item.zk_final_price }}</em>&nbsp;到手价
                                    </span>
                </div>
                <div class="freeListBtn_damai">
                  立即抢
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg_white mt12" v-show="nineData.status">
        <div class="flexBox flexBetween lh30">
          <div class="ml7">
            <span class="titleIconBox_damai iconfont icon-shoucang-tianchong titleIconBg2_damai"></span>
            <span class="titleLineBlock_damai ml5">9.9超值专区</span><em
              class="color_999 f8">&nbsp;&nbsp;·&nbsp;&nbsp;每日精选 全场包邮</em>
          </div>
          <div class="mr7 color_999 f8" v-on:click='toTopGoodsList("nine","9.9包邮")'>
            更多&nbsp;<em class="iconfont icon-mjiantou-copy f8"></em>
          </div>
        </div>
        <div class="myimg" v-on:click="toUrl(nineData.ad.url)">
          <img :src="nineData.ad.img"/>
        </div>
        <div class="flexBox">
          <div class="flexBox-cell-33" v-for="(item,index) in nineData.list"
               v-on:click="toTopGoodsDetail(item.num_iid)" :key="index">
            <div class="ml5 mr5">
              <ImageExt class="indexRecListImg mt5 tc" :src="item.pict_url"
                        mode="aspectFit"/>
              <p class="indexRecListTitle mt5">{{ item.title }}</p>
              <p class="f8 lh18"
                 :class="{'color_red': styleName === 'main','color_yellow': styleName === 'main_b','color_green': styleName === 'main_c'}">
                ￥<em class="f12">{{ item.coupon_after_price }}</em></p>
              <p class="color_999 f8">月销&nbsp;{{ item.volume }}</p>
              <div class="flexBox mt7 mb10">
                <div v-if="item.coupon_discount > 0">
                  <div class="paddingLR7"
                       :class="{'voucherBlock_damai': styleName === 'main','voucherBlock_damai_yellow': styleName === 'main_b','voucherBlock_damai_green': styleName === 'main_c'}">
                    {{ item.coupon_discount }}元券
                  </div>
                </div>
                <div v-else>
                  <div class="paddingLR7"
                       :class="{'voucherBlock_damai': styleName === 'main','voucherBlock_damai_yellow': styleName === 'main_b','voucherBlock_damai_green': styleName === 'main_c'}">
                    无券
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flexBox flexBetween bg_white lh30 mt12">
        <div class="ml7">
          <span class="titleIconBox_damai iconfont icon-shoucang"/>
          <span class="titleLineBlock_damai ml5">为您推荐</span>
          <em class="f8 color_999">&nbsp;&nbsp;·&nbsp;&nbsp;超级实惠 实时更新</em>
        </div>
        <div class="mr7 color_999 f8" v-on:click='toTopGoodsList("supercoupon")'>更多&nbsp;<em
            class="iconfont icon-mjiantou-copy f8"/></div>
      </div>

      <div class="h100">
        <IScroll @loadBottom="loadMore" ref="scrollWrap" id="scrollWrap">
          <slot name="title"></slot>
          <div class="goodInfoBoxList flexBetween mt7">
            <div class="indexGoodBlock mb5 flexBox-cell-48"
                 v-for="(item,index) in goodsData.list"
                 :key="index">
              <GoodsListItem :style-name="styleName" :goods-data="item"/>
            </div>
          </div>
        </IScroll>
        <div class="goTopBtn">
          <img v-if="topStatus" src="@/assets/images/backTop.png" v-on:click="toTop">
        </div>
      </div>
    </main>

    <BottomBar :style-name="styleName"/>
  </div>
</template>

<script>
import Swiper from 'swiper'
import '@/assets/css/swiper.css'
import BottomBar from './BottomBar';
import ImageExt from '../../components/ImageExt';
import IScroll from '../../components/IScroll';
import GoodsListItem from './TopGoodsListItem';

export default {
  name: 'Home',
  components: {IScroll, BottomBar, ImageExt, GoodsListItem},
  props: {
    styleName: {
      type: String,
      default: 'main'
    },
    bannerData: {
      type: Object,
      default() {
        return {
          status: false,
          list: []
        }
      }
    },
    headlineData: {
      type: Object,
      default() {
        return {
          status: false,
          list: []
        }
      }
    },
    advertAData: {
      type: Object,
      default() {
        return {
          status: false,
          advert1: {img: '', url: ''},
          advert2: {img: '', url: ''},
          advert3: {img: '', url: ''},
          advert4: {img: '', url: ''},
          advert5: {img: '', url: ''}
        }
      }
    },
    advertBData: {
      type: Object,
      default() {
        return {
          status: false,
          advert1: {img: '', url: ''},
          advert2: {img: '', url: ''},
          advert3: {img: '', url: ''},
          advert4: {img: '', url: ''},
          advert5: {img: '', url: ''}
        }
      }
    },
    shopData: {
      type: Object,
      default() {
        return {
          status: false,
          list: []
        }
      }
    },
    brandData: {
      type: Object,
      default() {
        return {
          status: false,
          ad: {img: '', url: ''},
          list: []
        }
      }
    },
    nineData: {
      type: Object,
      default() {
        return {
          status: false,
          ad: {img: '', url: ''},
          list: []
        }
      }
    },
    tljData: {
      type: Object,
      default() {
        return {
          status: false,
          ad: {img: '', url: ''},
          list: []
        }
      }
    },
    goodsData: {
      type: Object,
      default() {
        return {
          status: false,
          isMore: true,
          loading: false,
          list: []
        }
      }
    },
    isTop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      btnFlag: false
    }
  },
  computed: {
    topStatus() {
      return this.btnFlag && this.isTop;
    },
  },
  updated() {
    this.$refs.mainCon.addEventListener('scroll', this.mainScrollToTop)
    this.$refs.scrollWrap.$el.addEventListener('scroll', this.wrapScrollToTop);
  },
  watch: {
    'bannerData.status': function (status) {
      if (status) {
        this.$nextTick(() => {
          new Swiper('#swiperBanner', {
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            pagination: {
              el: '.swiper-pagination',
              paginationClickable: true,
            },
          });

        });
      }
    },
    'headlineData.status': function (status) {
      if (status) {
        this.$nextTick(() => {
          new Swiper('#headlines', {
            direction: 'vertical',
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            }
          });
        });
      }
    }
  },
  methods: {
    autoResizeImage: (maxWidth, maxHeight, event) => {
      let thisImg = event.currentTarget;
      let img = new Image();
      img.src = thisImg.src;
      let hRatio;
      let wRatio;
      let Ratio = 1;
      let w = img.width;
      let h = img.height;
      wRatio = maxWidth / w;
      hRatio = maxHeight / h;
      if (maxWidth === 0 && maxHeight === 0) {
        Ratio = 1;
      } else if (maxWidth === 0) {//
        if (hRatio < 1) Ratio = hRatio;
      } else if (maxHeight === 0) {
        if (wRatio < 1) Ratio = wRatio;
      } else if (wRatio < 1 || hRatio < 1) {
        Ratio = (wRatio <= hRatio ? wRatio : hRatio);
      }
      if (Ratio < 1) {
        w = w * Ratio;
        h = h * Ratio;
      }
      thisImg.height = h;
      thisImg.width = w;
    },
    loadMore: function () {
      this.$emit('loadMore', true);
    },
    toUrl: function (url) {
      if (url) window.location.href = url;
    },
    toSearch: function () {
      this.$router.push({name: 'search'});
    },
    toCategory: function () {
      this.$router.push({name: 'category'});
    },
    toTopGoodsList: function (type) {
      const route = {
        name: 'top-goods-list',
        query: {
          type: type
        }
      };
      this.$router.push(route);
    },
    toTopGoodsDetail: function (id) {
      const route = {
        name: 'top-goods-detail',
        query: {
          id
        }
      };
      this.$router.push(route);
    },
    toJdGoodsMain: function () {
      this.$router.push({name: 'jd-goods-main'});
    },
    toPddGoodsMain: function () {
      this.$router.push({name: 'pdd-goods-main'});
    },
    toTopRealList: function () {
      this.$router.push({name: 'top-real-list'})
    },
    toTopBrandList: function () {
      this.$router.push({name: 'top-brand-list'})
    },
    toTopFreeList: function () {
      this.$router.push({name: 'top-free-list'})
    },
    toArticleDetail: function (id) {
      const route = {
        name: 'article-detail',
        query: {
          id
        }
      };
      this.$router.push(route);
    },
    toEnroll: function () {
      this.$router.push({name: 'enroll'});
    },
    toShop: function () {
      this.$router.push({name: 'shop'})
    },
    toShopDetail: function (id) {
      const route = {
        name: 'shop-detail',
        query: {
          id
        }
      };
      this.$router.push(route);
    },
    toTop: function (top) {
      document.getElementById('mainCon').scrollTop = top;
      document.getElementById('scrollWrap').scrollTop = top;
    },
    mainScrollToTop: function () {
      this.btnFlag = document.getElementById('mainCon').scrollTop > 180;
      this.$emit('mainScrollToTop', document.getElementById('mainCon').scrollTop);
    },
    wrapScrollToTop: function () {
      this.$emit('wrapScrollToTop', document.getElementById('scrollWrap').scrollTop);
    },
    setScrollPosition: function (mainScrollTop, wrapScrollToTop) {
      document.getElementById('mainCon').scrollTop = mainScrollTop;
      document.getElementById('scrollWrap').scrollTop = wrapScrollToTop;
    }
  }
}
</script>

<style scoped>

</style>
